<template>
    <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

        <vs-dropdown class="cursor-pointer nav-text-container" vs-custom-content vs-trigger-click>
            <div class="text-right leading-tight hidden sm:block cursor-pointer"
                 @click="$router.push(`/${activeUserInfo.userRole}/profile`).catch(() => {})">
                <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
                <small>{{ activeUserInfo.email }}</small>
            </div>

            <div class="con-img ml-3">
                <vs-avatar v-if="activeUserInfo.displayName" :text="activeUserInfo.displayName" color="primary"/>
            </div>

            <vs-dropdown-menu class="vx-navbar-dropdown">
                <ul style="min-width: 9rem">

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                        @click="$router.push(`/${activeUserInfo.userRole}/profile`).catch(() => {})">
                        <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
                        <span class="ml-2">Profile</span>
                    </li>

                    <!--<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="MailIcon" svgClasses="w-4 h-4"/>
                        <span class="ml-2">Inbox</span>
                    </li>

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4"/>
                        <span class="ml-2">Tasks</span>
                    </li>

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4"/>
                        <span class="ml-2">Chat</span>
                    </li>

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="HeartIcon" svgClasses="w-4 h-4"/>
                        <span class="ml-2">Wish List</span>
                    </li>-->

                    <vs-divider class="m-1"/>

                    <li
                        @click="logout"
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
                        <span class="ml-2">Logout</span>
                    </li>
                </ul>
            </vs-dropdown-menu>
        </vs-dropdown>
    </div>
</template>

<script>
import keycloak from '../../../../services/KeycloakService';

export default {
    data() {
        return {}
    },
    computed: {
        activeUserInfo() {
            return this.$store.state.AppActiveUser
        }
    },
    methods: {
        logout() {
            keycloak.logout();
        },
    }
}
</script>


<style lang="scss">
.nav-text-container {
    flex-direction: row;
    display: flex;
    align-items: center;
    font-family: "Montserrat", Helvetica, Arial, sans-serif;
}
</style>
